import { Outlet } from '@tanstack/react-router';

/**
 * The root renders nothing of its own.
 *
 * Chrome belongs to the two layout routes beneath it: the pathless `app` route wraps every
 * customer screen in the app shell, and `/admin` wraps the support console in its own.
 */
export function RootLayout() {
  return <Outlet />;
}
